import { Helmet } from "react-helmet-async"

import { Box } from "components/common"
import { jewlr_t } from "helpers/application"
import { SectionTitle } from "jewlr/pages/components"
import ImageTextBlock from "jewlr/pages/image-text-block"

import Accessories from "./accessories"
import BestSellers from "./best-sellers"
import MainBanner from "./main-banner"
import OtherCollections from "./othe-collections"

const CollectionsForHim = () => (
  <>
    <Helmet>
      <title>Collections For Him</title>
    </Helmet>
    <MainBanner />
    <Box contain>
      <Box mb={{ _: 4, desktop: 6 }} textAlign="center">
        <SectionTitle>He will LOVE these.</SectionTitle>
      </Box>
      <ImageTextBlock
        element={{
          description: "A meaningful symbol of love and commitment.",
          image: "collections-for-him/mens-promise",
          link: "/mens-promise-rings",
          title: "Men's Promise Rings",
        }}
      />
      <ImageTextBlock
        element={{
          description: "Modern designs made just for him.",
          display: "flex",
          image: "collections-for-him/mens-bracelets",
          link: "/mens-bracelets",
          title: "Men's Bracelets",
        }}
      />
      <ImageTextBlock
        element={{
          description: "Classic designs for everyday styles.",
          display: "flex",
          image: "collections-for-him/mens-necklaces",
          link: "/mens-necklaces",
          textPosition: "left",
          title: "Men's Necklaces",
        }}
      />
      <ImageTextBlock
        element={{
          description: `${jewlr_t(
            "terms.Personalize"
          )} a timeless wedding band for him.`,
          image: "collections-for-him/mens-wedding-bands",
          link: "/mens-wedding-bands",
          title: "Men's Wedding Bands",
        }}
      />
      <Box mb={6}>
        <Accessories />
      </Box>
      <ImageTextBlock
        element={{
          description: `Discover great deals on ${jewlr_t(
            "terms.personalized"
          )} ${jewlr_t("terms.jewelry")}.`,
          display: "flex",
          image: "collections-for-him/sale-for-him",
          link: "/sale-for-him",
          title: "On Sale For Him",
        }}
      />

      <BestSellers />
      <OtherCollections />
    </Box>
  </>
)

export default CollectionsForHim
